import React from 'react'
import TokenVerify from '../components/EmailVerify/TokenVerify'

const TOkenVerifyPage = () => {
  return (
    <div>
        <TokenVerify />
    </div>
  )
}

export default TOkenVerifyPage
